<mat-grid-list [cols]="columnas" rowHeight="100vh" (window:resize)="onResize($event)" style="overflow-x: hidden;">
    <mat-grid-tile [colspan]="colspanImg" class="columna" *ngIf="!columnaOculta">
        <img src="./assets/images/Logo-IC-transparente.png" alt="Logo IC" class="img">
    </mat-grid-tile>
    <mat-grid-tile [colspan]="colspanError" class="columnaDos">
        <div class="mensaje-zone">
            <p class="p-mensaje" *ngIf="respuesta === '1'">Acabas de firmar con la <br/> Firma Digital de ICONSTRUYE &reg;</p>
            <p class="p-mensaje" *ngIf="respuesta === '2'">Documento ha sido rechazado desde la plataforma de <br/> Firma Digital de ICONSTRUYE &reg;</p>
            <p class="p-mensaje" *ngIf="respuesta === '3'">Documento cancelado desde la plataforma de <br/> Firma Digital de ICONSTRUYE &reg;</p>
            <p class="p-mensaje" *ngIf="respuesta === '4'">RUT no existe para este proceso de <br/> Firma Digital de ICONSTRUYE &reg;</p>
            <p class="p-mensaje" *ngIf="respuesta === '5'">Documento ya fue firmado desde la plataforma de <br/> Firma Digital de ICONSTRUYE &reg;</p>
            <p class="p-mensaje" *ngIf="respuesta === '6'">No es posible continuar con el proceso, existe un error en la solicitud generada.</p>
        </div>
    </mat-grid-tile>
</mat-grid-list>

<div class="divLogo" *ngIf="columnaOculta">
    <img src="./assets/images/Logo-IC.png" alt="Logo IC" class="logo">
</div>